import React from "react";
import "./MattermostBlock.scss";
import {Text} from "../../../../modules";
import {useTranslation} from "react-i18next";
import {Button} from "../../../../modules/Button";
import {useSelector} from "react-redux";
import {useCalendarActions} from "../../hooks";

const MattermostBlock = () => {
    const {t} = useTranslation();
    const {GetAuthorizationUrlMattermost, LogOutMattermost} = useCalendarActions();
    const userProfile = useSelector(state => state.profile.userProfile);

    return (
        <div className="calendars-block">
            <Text font="medium" size="f18" className="calendars-block--title">
                Mattermost
            </Text>
            {userProfile?.mattermost_connected ? (
                <>
                    <div className="calendars-block__info">
                        <div className="calendars-block__info--text">
                            <Text size="f14" font="book" color="#9898A6" as="p">
                                {" "}
                                {t("mattermost_connected_sub_title")}{" "}
                            </Text>
                        </div>
                        <Button
                            text={t("calendar_settings_disconnect")}
                            onClick={LogOutMattermost}
                            variant="secondary"
                            color="red"
                            size="s"
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="calendars-block__top">
                        <Text font="liteMedium" size="f16" color="#9898A6">
                            {t('mattermost_connected_desc')}
                        </Text>
                    </div>
                    <div className="calendars-block__bottom">
                        <Text font="liteMedium" size="f16" color="#9898A6">
                            {t('mattermost_connected_desc_btn')}
                        </Text>
                        <Button
                            text={t("connect")}
                            size="s"
                            onClick={GetAuthorizationUrlMattermost}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default MattermostBlock;
